import { createApp } from 'vue'
import App from './App.vue'
import Vue from 'vue'
import router from './router'
import axios from "axios";
import mitt from 'mitt';
const emitter = mitt();
import Datatable from "@/views/customTable/Datatable";

// export const bus = new Vue();
// export const bus = new Vue();

axios.interceptors.request.use((config) => {

    if (config.show_pros == null) {
        // bus.$emit("show_spinner", 'true');
        emitter.emit("show_spinner", true);

    }

    return config;
}, (error) => {
    // trigger 'loading=false' event here
    // console.log("axios false");
    emitter.emit("show_spinner", false);

    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    // trigger 'loading=false' event here
    // bus.$emit("show_spinner", 'false');
    emitter.emit("show_spinner", false);

    return response;
}, (error) => {
    // trigger 'loading=false' event here
    // bus.$emit("show_spinner", 'false');
    emitter.emit("show_spinner", false);

    return Promise.reject(error);
});
axios.defaults.baseURL = "https://db.cinnet.ir/";
// axios.defaults.baseURL = "http://localhost:8000/";


const mixin = {
    created() {
    },
    methods: {
        name_to_slug(title) {
           return  title.replace(/ /g, "-")
        },
        get_date(date){
            return new Date(date).toLocaleDateString('IR-fa')
        }
    }
}
import ToastPlugin from 'vue-toast-notification';
import CKEditor from '@ckeditor/ckeditor5-vue';
import "@flaticon/flaticon-uicons/css/all/all.css"
// import Vueditor from 'vueditor'
// import Vuex from 'vuex'
// import 'vueditor/dist/style/vueditor.min.css'

// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import CInput from "@/views/CustomComponent/CInput.vue";
import CTextarea from "@/views/CustomComponent/CTextarea.vue";
import CButton from "@/views/CustomComponent/CButton.vue";
const app = createApp(App);
app.component('MyComponent', Datatable)
app.component('CInput', CInput)
app.component('CTextarea', CTextarea)
app.component('CButton', CButton)
app.mixin(mixin)
app.use(ToastPlugin);
app.use(CKEditor );
// app.use(Vuex);
// app.use(Vueditor);
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.axios = axios;
app.use(router,axios)
app.mount('#app')
